import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { Program } from '@model';
import { GridProgramService } from '@service';

/**
 * Interface for scenario view resolver data
 * Provides named properties instead of tuple indices for better type safety
 */
export interface ScenarioViewResolverData {
  programsDetail: Program[];
  customPrograms: Program[];
}

/**
 * Scenario view resolver function (Angular 14+ functional API)
 * Replaces the deprecated class-based ScenarioViewResolver
 * 
 * @returns Observable of tuple [Program[], Program[]] for backward compatibility
 */
export const scenarioViewResolver: ResolveFn<[Program[], Program[]]> = (
  route: ActivatedRouteSnapshot
) => {
  const gridProgramService = inject(GridProgramService);

  const scenarioId =
    route.queryParamMap.get('scenarioId') || route.paramMap.get('scenarioId');

  let programsDetail$ = of<Program[]>([]);
  let customPrograms$ = of<Program[]>([]);

  if (scenarioId) {
    programsDetail$ = gridProgramService.programsDetail$(scenarioId);
    customPrograms$ = gridProgramService.customPrograms$(scenarioId);
  }

  return forkJoin([programsDetail$, customPrograms$]);
};
